/**
 * Replace accented characters in a string with their unaccened equivilant.
 * Primarily used for searching.
 * @param {*} s The string the replate the characters with
 * @returns The unaccented sring
 */
export const deaccent = (s) => {
    return s ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, "") : ''
}